export const IESUBSCRIPTIONS_RESET_STATE = 'IESUBSCRIPTIONS_RESET_STATE';
export const IESUBSCRIPTIONS_CURRENT_ITEM = 'IESUBSCRIPTIONS_CURRENT_ITEM';

export const IESUBSCRIPTIONS_REQUEST_LOADING = 'IESUBSCRIPTIONS_REQUEST_LOADING';
export const IESUBSCRIPTIONS_REQUEST_SUCCESS = 'IESUBSCRIPTIONS_REQUEST_SUCCESS';
export const IESUBSCRIPTIONS_REQUEST_FAILED = 'IESUBSCRIPTIONS_REQUEST_FAILED';

export const IESUBSCRIPTIONS_CURRENT_ACTION = 'IESUBSCRIPTIONS_CURRENT_ACTION';
export const IESUBSCRIPTIONS_RESET_ACTION = 'IESUBSCRIPTIONS_RESET_ACTION';
